module.exports = __webpack_public_path__ + "img/icon1.7fbfece4.svg";